import type { LoginFormErrors, LoginFormValues } from "../model/types";

/**
 * 숨김 ID/PW 로그인(dev 전용 review-login) 폼 검증.
 * 심사용 계정이라 형식/길이 규칙 없이 아이디·비밀번호가 비어있지 않은지만 확인한다.
 */
export const validateLoginForm = ({ id, password }: LoginFormValues): LoginFormErrors => {
  const errors: LoginFormErrors = {};

  if (!id) errors.id = "아이디를 입력해주세요.";
  if (!password) errors.password = "비밀번호를 입력해주세요.";

  return errors;
};
